module.exports = __webpack_public_path__ + "static/media/BOT-1.153452d0.png";